import React from 'react';
import PropTypes from 'prop-types';

export const ArrowDown = ({ width, height, ...props }) => (
  <svg
    data-icon='arrow-down'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12 12.6 7.4 8 6 9.4l6 6 6-6L16.6 8 12 12.6Z'
    />
  </svg>
);

ArrowDown.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

ArrowDown.defaultProps = {
  width: 24,
  height: 24,
};
